// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__28Gs9","icon":"EnquiryForm_icon__6DqLZ","heading":"EnquiryForm_heading__3FvDE","field":"EnquiryForm_field__PUotW","error":"EnquiryForm_error__1erGl"};